import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { CustomCircularProgress } from 'Components/StyledComponents';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import SignUp from './SignUp';
import { useMediaQuery } from '@mui/material';
import IntroFlowBack from 'Components/IntroFlowBack';
import Logo from 'Components/Logo';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';
import { awsRum } from 'Utils/AwsRum';

const Signup: FC<{}> = () => {
  const navigate = useNavigate();
  const { userLevelData } = useSelector((state: MainAppReducer) => state.mainAppReducer);

  const _matchesHeight = useMediaQuery('(max-height:800px)');
  const _matchesWidth = useMediaQuery('(max-width:750px)');

  const { processPending, currentAuthToken, setPendingEmailOrPhone, resetErrors } =
    useAuthWrapperContext();

  useEffect(() => {
    currentAuthToken()
      .then((jwtToken) => {
        if (jwtToken) {
          if (setPendingEmailOrPhone) setPendingEmailOrPhone(undefined);
          if (userLevelData.length) {
            console.log('[MUS-61] SignUp: has userLevelData → /roadmap');
            navigate('/roadmap');
          } else {
            console.log('[MUS-61] SignUp: no userLevelData → /welcome');
            navigate('/welcome');
          }
        }
      })
      .catch((err) => {
        console.error('Error getting current auth token:', err);
        awsRum?.recordError(err);
      });
  }, [navigate, userLevelData, setPendingEmailOrPhone, currentAuthToken]);

  return (
    <Box className="page-div-styles">
      <Box className="filter-div-styles">
        <Box className="sign-in-div-styles">
          <IntroFlowBack />
          <Logo />
          <Box className="desc-container welcome-container">
            {processPending && (
              <Box
                sx={{
                  display: 'flex',
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '100px',
                }}
              >
                <CustomCircularProgress />
              </Box>
            )}
            <h3 className="title-welcome title-welcome-long" style={{ marginTop: '50px' }}>
              Create your MuseFlow account
            </h3>
            <SignUp
              goBackFn={() => {
                if (resetErrors) resetErrors();
                navigate('/signin');
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Signup;
